export const BORDER_RADIUS = {
    A: 4,
    B: 8,
    C: 16,
    D: 24,
    NONE: 0,
    PILL: 180,
};
export const getCFBorderRadius = (borderRadius) => {
    if (Object.keys(BORDER_RADIUS).includes(borderRadius.toUpperCase())) {
        return BORDER_RADIUS[borderRadius.toUpperCase()];
    }
    return BORDER_RADIUS.NONE;
};
